import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {Link} from 'react-router-dom';


// Styled Components


const RecommendWrapper = styled.div`
    display: flex;
    width: 478px;
    align-items: flex-start;
    flex-direction: column;
    padding-top: 10px;
    padding-left: 100px;
    color: #333;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    line-height: 1.5;
`;

const SubHeading = styled.h1`
    font-family: 'Nunito Sans', sans-serif;
    font-size: 35px;
    color: #707070;
    text-align: left;
    letter-spacing: 0px;
    line-height: 47px;
    margin: 0 0 20px 0;
`;

const InputBox = styled.input`
    width: 320px;
    padding: 10px;
    font-size: 16px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    margin-bottom: 10px;
`;



const ButtonWrapper = styled.div`
    display: flex;
`;

// Colors
const recommendBorderColor = '#54BAB2';
const recommendBorderHoverColor = 'rgba(246,155,66,0.62)';
const recommendTextColor = '#ffffff';
const recommendTextHoverColor = 'rgb(255,255,255)';

const RecommendButton = styled(Link)`
    position: relative;
    top: 0px;
    left: 0px;
    width: 131px;
    height: 42px;
    border: none; /* Remove border */
    border-radius: 0px;
    cursor: pointer;
    font-family: 'Oswald', sans-serif;
    font-weight: normal;
    padding: 4px 0px;
    text-transform: uppercase;

    font-size: 24px;
    color: ${recommendTextColor};
    text-align: center;
    line-height: 36px; /* Adjust line height to vertically center the text */
    background-color: ${recommendBorderColor}; /* Set solid background */
    transition: transform 0.2s, background-color 0.2s;

    &:hover {
        transform: scale(1.1);
        background-color: ${recommendBorderHoverColor}; /* Change background color on hover */
        color: ${recommendTextHoverColor}; /* Change text color on hover */
    }
`;



// Component
const RecommendResource = ({ onSubmit }) => {
    return (
        <RecommendWrapper>
            <SubHeading>
                Mamas, recommend
                <br />
                a resource!
            </SubHeading>
            <InputBox type="text" placeholder="Enter your recommendation" />
            <ButtonWrapper>
                <RecommendButton onClick={onSubmit}>SEND</RecommendButton>
            </ButtonWrapper>
        </RecommendWrapper>
    );
};

// Prop Types
RecommendResource.propTypes = {
    onSubmit: PropTypes.func.isRequired,
};

export default RecommendResource;